<template>
	<page>
		<v-row>
			<title-view>
				ביצוע ההגרלה
			</title-view>
		</v-row>
		<v-row>
			<v-col cols="4">
				<lottery-url v-if="lottery" @change="changeUrl"/>
				<div v-if="srcUrl !== ''" class="mt-6">
					<v-btn  depressed color="green" class="white--text" :href="srcUrl" target="_blank">בצע הגרלה במסך מלא</v-btn>
				</div>
			</v-col>
			<v-col cols="8" class="wrapper justify-center" v-if="srcUrl !== '' ">
				<iframe
					:src="srcUrl"
					title="הגרלות"
				></iframe>
			</v-col>
		</v-row>
	</page>
</template>

<script>
	import LotteryUrl from "./LotterySettings";
	import LotteryModule from "src/store/modules/Lottery.module";

	export default {
		components: {LotteryUrl},
		name: "lottery-iframe",
		data() {
			return {
				openModal: false,
				srcUrl: ""
			};
		},
		computed: {
			url() {
				return this.srcUrl;
			},
			lottery() {
				return this.$store.state.LotteryModule.lottery;
			}
		},
		methods: {
			open() {
				this.openModal = !this.openModal;
			},
			async changeUrl({startRandTime, endRandTime, totalCount, lottery, package_id}) {
				// await this.$store.dispatch(LotteryModule.types.GET, lottery);
				let packages = package_id.map(el => el.id);
				let url = `${window.location.origin}/api/lottery/cards/${lottery.uuid}${package_id ? `?package_id=${packages}` : ""}`;
				this.openModal = !this.openModal;
				this.srcUrl = `https://closeapp.co.il/apps/pash/games/assets/imageShow/lottery.html?startRandTime=${startRandTime}&endRandTime=${endRandTime}&totalCount=${totalCount}&jsonLink=${url}&sendBack=.php`;
			},
		}
	};
</script>

<style scoped>
    .wrapper {
        position: relative;
        padding-bottom: 56.25%; /* 16:9 */
        padding-top: 25px;
        height: 0;
        display: flex;
    }

    .wrapper iframe {
        position: absolute;
        width: 100%;
        height: 100%;
    }

</style>
